export const APP_BRAND_NAME = "PAPI HAIR DESIGN";
export const APP_BRAND_SLUG = "papi-hair-design";
export const APP_LOGO_SRC = "/phd-logo.png";

export const APP_CANONICAL_HOST = "booking.papihairdesign.sk";
export const APP_SITE_URL = `https://${APP_CANONICAL_HOST}`;
export const APP_ICS_DOMAIN = "papihairdesign.sk";

export const APP_CONTACT_EMAIL = "papihairdesign@gmail.com";
export const APP_BOOKING_EMAIL = "booking@papihairdesign.sk";
export const APP_CONTACT_PHONE = "+421949459624";
export const APP_CONTACT_PHONE_DISPLAY = "+421 949 459 624";

export const APP_ADDRESS = {
  street: "Tr. SNP 61A",
  locality: "Košice",
  countryCode: "SK",
} as const;

export const APP_MAP_URL =
  "https://www.google.com/maps/search/?api=1&query=Tr.%20SNP%2061A%2C%20Spolo%C4%8Densk%C3%BD%20pavil%C3%B3n%2C%20Ko%C5%A1ice";
